const SCHEDULING_CALENDAR_VIEW_CLASSIC = "classic";
const SCHEDULING_CALENDAR_VIEW_GANTT = "gantt";
const SCHEDULING_OFS_VIEW_LIST = "list";
const SCHEDULING_OFS_VIEW_GANTT = SCHEDULING_CALENDAR_VIEW_GANTT;
/**
 * object whose keys and values are the ones in the array
 * better readibility invoking e.g. `.month` rather than `[0]` with a normal array
 */

const SCHEDULING_GANTT_MESHES_OPTIONS = {
  month: "month",
  "two-weeks": "two-weeks",
  week: "week",
};
const SCHEDULING_GANTT_SHIFTS_OPTIONS = {
  morning: "M",
  afternoon: "AM",
  night: "N",
};

const CSS_SCHEDULING_GANTT_CELL_CLASS = "gantt--cell";
const SCHEDULING_GANTT_PER_PAGE_IDENTIFIER = "ganttPerPage";
const SCHEDULING_GANTT_PER_PAGE_DEFAULT_VALUE = 50;

const SCHEDULING_TAGS_DEFAULT_COLOR = "newPrimaryLight2";
const SCHEDULING_TAGS_AVAILABLE_COLORS = [
  "newGreenLight2",
  SCHEDULING_TAGS_DEFAULT_COLOR,
  "newPurpleLight2",
  "newPinkLight2",
  "newOrangeLight2",
  "newLightGrey",
];

const SCHEDULING_COLOR_CATEGORY_ID_SCHEDULING_CALENDAR_PLANNING =
  "planning__calendar__color_category";
const SCHEDULING_COLOR_CATEGORY_ID_OFS_PLANNING =
  "planning__ofs__color_category";
const SCHEDULING_COLOR_CATEGORY_ID_SCHEDULING_CALENDAR_PILOTING =
  "piloting__calendar__color_category";
const SCHEDULING_COLOR_CATEGORY_ID_OFS_PILOTING =
  "piloting__ofs__color_category";
const SCHEDULING_COLOR_CATEGORY_ID_EN_COURS_PILOTING =
  "piloting__en_cours__color_category";

const SCHEDULING_GROUP_BY_ID_SCHEDULING_CALENDAR_PLANNING =
  "planning__calendar__group_by";
const SCHEDULING_GROUP_BY_ID_SCHEDULING_CALENDAR_PILOTING =
  "piloting__calendar__group_by";
const SCHEDULING_GROUP_BY_ID_EN_COURS_PILOTING = "piloting__en_cours__group_by";
const SCHEDULING_CALENDAR_DEFAULT_COLUMN_WIDTH = 250;

const SCHEDULING_KEY_FIELDS_FOR_AI_RULES = ["tags", "fast_track", "incident"];
const SCHEDULING_EXCLUDED_FIELDS_FOR_AI_RULES = [
  "erp_id",
  "unite_of",
  "unite_op",
  "unite_op_2",
];

const CSS_SCHEDULING_OPERATION_PRIORITY_CHIP_CLASS = "chip";

enum PRIORITY_RULES_OPTIONS {
  CLIENT_DELAY = "client_delay",
  PRIORITY = "priority",
  STAGNATION = "stagnation",
  OP_DELAY = "op_delay",
}
const PRIORITY_RULES_STORAGE_IDENTIFIER = "filter_priorityRules";
const ENABLE_MANUAL_SORTING_STORAGE_IDENTIFIER = "filter_enableManualSorting";
const IGNORE_ONGOING_SORT_IDENTIFIER = "filter_ignoreOnGoingSort";

const LOCAL_STORAGE_SCHEDULING_FILTER_KEY = "schedulingFilters";
const LOCAL_STORAGE_CALENDAR_FILTER_KEY = "calendarSchedulingFilters";
const LOCAL_STORAGE_TABLE_FILTER_KEY = "tableFilters";
const LOCAL_STORAGE_GANTT_FILTER_KEY = "ganttFilters";

const CAPACITY_TABLE_DEFAULT_DAILY_VALUE = null;

const LIST_OFS_ABSOLUTE_OFS_STORAGE_ID = "list_absolute_ofs";
const LIST_OFS_CONCATENATED_OFS_STORAGE_ID = "list_concatenated_ofs";

const OPERATION_CARD_V_LAZY_MIN_HEIGHT = 90;
const OPERATION_ROW_V_LAZY_MIN_HEIGHT = 20;

const USER_PARAMETERS_SELECTED_SECTORS_KEY = "scheduling__selected_sectors";
const USER_PARAMETERS_SELECTED_SECTORS_ON_GOING_KEY =
  "scheduling__selected_sectors__on_going";

const DEFAULT_HIDDEN_OPERATION_CARD_INFO = ["subheader", "opQty"];

enum DISPLAYED_STATUS_OPTIONS {
  AVAILABLE = "available",
  ON_GOING = "on-going",
  POF = "pof",
  N0 = 0,
  N1 = 1,
  N2 = 2,
  N3 = 3,
  N4 = 4,
  N5 = 5,
  N6 = 6,
  N7 = 7,
  N8 = 8,
  N9 = 9,
  N10 = 10,
  OTHER = -1,
}
const DEFAULT_DISPLAYED_STATUS = [
  DISPLAYED_STATUS_OPTIONS.AVAILABLE,
  DISPLAYED_STATUS_OPTIONS.ON_GOING,
];

export {
  SCHEDULING_OFS_VIEW_LIST,
  SCHEDULING_CALENDAR_VIEW_CLASSIC,
  SCHEDULING_CALENDAR_VIEW_GANTT,
  SCHEDULING_GANTT_MESHES_OPTIONS,
  SCHEDULING_GANTT_SHIFTS_OPTIONS,
  SCHEDULING_OFS_VIEW_GANTT,
  CSS_SCHEDULING_GANTT_CELL_CLASS,
  SCHEDULING_GANTT_PER_PAGE_IDENTIFIER,
  SCHEDULING_GANTT_PER_PAGE_DEFAULT_VALUE,
  SCHEDULING_TAGS_DEFAULT_COLOR,
  SCHEDULING_TAGS_AVAILABLE_COLORS,
  SCHEDULING_COLOR_CATEGORY_ID_SCHEDULING_CALENDAR_PLANNING,
  SCHEDULING_COLOR_CATEGORY_ID_OFS_PLANNING,
  SCHEDULING_COLOR_CATEGORY_ID_SCHEDULING_CALENDAR_PILOTING,
  SCHEDULING_COLOR_CATEGORY_ID_OFS_PILOTING,
  SCHEDULING_COLOR_CATEGORY_ID_EN_COURS_PILOTING,
  SCHEDULING_GROUP_BY_ID_SCHEDULING_CALENDAR_PLANNING,
  SCHEDULING_GROUP_BY_ID_SCHEDULING_CALENDAR_PILOTING,
  SCHEDULING_GROUP_BY_ID_EN_COURS_PILOTING,
  SCHEDULING_CALENDAR_DEFAULT_COLUMN_WIDTH,
  SCHEDULING_KEY_FIELDS_FOR_AI_RULES,
  SCHEDULING_EXCLUDED_FIELDS_FOR_AI_RULES,
  CSS_SCHEDULING_OPERATION_PRIORITY_CHIP_CLASS,
  PRIORITY_RULES_OPTIONS,
  PRIORITY_RULES_STORAGE_IDENTIFIER,
  ENABLE_MANUAL_SORTING_STORAGE_IDENTIFIER,
  IGNORE_ONGOING_SORT_IDENTIFIER,
  CAPACITY_TABLE_DEFAULT_DAILY_VALUE,
  LIST_OFS_ABSOLUTE_OFS_STORAGE_ID,
  LIST_OFS_CONCATENATED_OFS_STORAGE_ID,
  OPERATION_CARD_V_LAZY_MIN_HEIGHT,
  LOCAL_STORAGE_SCHEDULING_FILTER_KEY,
  LOCAL_STORAGE_CALENDAR_FILTER_KEY,
  LOCAL_STORAGE_TABLE_FILTER_KEY,
  LOCAL_STORAGE_GANTT_FILTER_KEY,
  OPERATION_ROW_V_LAZY_MIN_HEIGHT,
  USER_PARAMETERS_SELECTED_SECTORS_KEY,
  USER_PARAMETERS_SELECTED_SECTORS_ON_GOING_KEY,
  DEFAULT_HIDDEN_OPERATION_CARD_INFO,
  DISPLAYED_STATUS_OPTIONS,
  DEFAULT_DISPLAYED_STATUS,
};
